import React from 'react';
import { useEffect } from 'react';
import { emitToast, useToast } from '../components/ToastProvider';

type StatusLike = { type: string; text: string } | null | undefined;

type UseErrorNotificationOptions = {
  header?: string;
  duration?: number;
};

const DEFAULT_DURATION = 8000;

export function useErrorNotification(
  status: StatusLike,
  { header = 'Error', duration = DEFAULT_DURATION }: UseErrorNotificationOptions = {}
) {
  const { pushToast } = useToast();
  useEffect(() => {
    if (status?.type === 'err' && status.text) {
      pushToast({
        title: header,
        message: status.text,
        variant: 'danger',
        durationMs: duration,
      });
    }
  }, [duration, header, pushToast, status]);
}

export function showErrorNotification(
  message: string,
  { header = 'Error', duration = DEFAULT_DURATION }: UseErrorNotificationOptions = {}
) {
  if (!message) return;

  emitToast({
    title: header,
    message,
    durationMs: duration,
    variant: 'danger',
  });
}
